var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSoftwareFixing(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_51_29",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 70,
    height: 70
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_51_29)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0208 34.8545H20.4896V26.2503H29.0938V20.7816H15.0208V34.8545ZM40.9062 49.2191H54.9792V35.1462H49.5104V43.7503H40.9062V49.2191ZM12.0312 57.6774C10.5243 57.6774 9.23611 57.1427 8.16667 56.0732C7.09722 55.0038 6.5625 53.7156 6.5625 52.2087V17.792C6.5625 16.285 7.09722 14.9969 8.16667 13.9274C9.23611 12.858 10.5243 12.3232 12.0312 12.3232H57.9688C59.4757 12.3232 60.7639 12.858 61.8333 13.9274C62.9028 14.9969 63.4375 16.285 63.4375 17.792V52.2087C63.4375 53.7156 62.9028 55.0038 61.8333 56.0732C60.7639 57.1427 59.4757 57.6774 57.9688 57.6774H12.0312ZM12.0312 52.2087H57.9688V17.792H12.0312V52.2087Z",
    fill: "#E7E7E7"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSoftwareFixing);
export default __webpack_public_path__ + "static/media/icon_software-fixing.dd8d8938e21cc7a4a59288f49f010ce4.svg";
export { ForwardRef as ReactComponent };